export default "__VITE_ASSET__H49KG108__"